import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Button, Box, Drawer } from '@mui/material';
import DrawerHeader from 'app/components/shared/DrawerHeader';
import { useFilePlayerContext } from '../FilePlayerContext';
import { FileGroupFilesPanel } from './FileGroupFilesPanel';

export const FileGroupItem = ({ group, groupBy }) => {
  const { playItems, allFiles } = useFilePlayerContext();
  const [open, setOpen] = useState(false);

  const handleOpenDrawer = () => setOpen(true);
  const handleCloseDrawer = () => setOpen(false);

  const handlePlayAll = (e) => {
    e.stopPropagation();
    const filesForGroup = allFiles.filter((file) => {
      return groupBy === 'date'
        ? file.acquiredAt?.startsWith(group.date)
        : String(file.advisorId) === String(group.advisor_id);
    });
    playItems(filesForGroup);
  };

  const drawerLabel = groupBy === 'date'
    ? `Added ${group.date}`
    : `Files from ${group.advisor_login}`;

  const filters = groupBy === 'date'
    ? { date: group.date }
    : { advisor_id: group.advisor_id };

  return (
    <>
      <Box
        onClick={handleOpenDrawer}
        sx={{
          borderRadius: 2,
          border: '1px solid #ccc',
          px: 2,
          py: 1,
          cursor: 'pointer',
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="body1" fontWeight="bold">
              {groupBy === 'date' ? `Added ${group.date}` : group.advisor_login}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {group.file_count}
              {' '}
              files
            </Typography>
          </Box>
          <Button onClick={handlePlayAll}>Play All</Button>
        </Stack>
      </Box>

      <Drawer
        anchor="right"
        open={open}
        onClose={handleCloseDrawer}
        PaperProps={{ sx: { width: { xs: '100%', sm: 500 } } }}
      >
        <DrawerHeader closeDrawer={handleCloseDrawer} headerCopy={drawerLabel} />
        <FileGroupFilesPanel
          filters={filters}
          label={drawerLabel}
          advisorLogin={group.advisor_login}
        />
      </Drawer>
    </>
  );
};

FileGroupItem.propTypes = {
  group: PropTypes.shape({
    date: PropTypes.string,
    advisor_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    advisor_login: PropTypes.string,
    file_count: PropTypes.number.isRequired,
  }).isRequired,
  groupBy: PropTypes.oneOf(['date', 'advisor_login']).isRequired,
};
